module.exports = __webpack_public_path__ + "img/anikin.7d91fd21.png";